/**
 * Returns the nav item whose path matches `pathname`, or undefined when
 * nothing matches. Pure — no SPA coupling.
 *
 * Matching rules (in priority order):
 * 1. Exact path match.
 * 2. Longest prefix match (e.g. /flows/abc → "flows").
 */
export function findActiveNavItem(navGroups, pathname) {
    const allItems = navGroups.flatMap((g) => g.items);
    // Exact match wins.
    const exact = allItems.find((i) => i.path === pathname);
    if (exact)
        return exact;
    // Prefix match (e.g. /flows/abc123 → flows), longest wins.
    const prefix = allItems
        .filter((i) => Boolean(i.path) && pathname.startsWith(i.path + '/'))
        .sort((a, b) => b.path.length - a.path.length)[0];
    return prefix;
}
//# sourceMappingURL=nav-types.js.map